import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import TextField from '@material-ui/core/TextField';
import FormTextField from 'components/FormElements/FormTextField';
import {
  default as TooltipModal,
  TooltipContent,
  TooltipHeader,
} from 'components/Utility/TooltipModal';
import moment from 'moment';
import React, { useState } from 'react';
import IntlTelInput from 'react-intl-tel-input';
import 'react-intl-tel-input/dist/main.css';
import { Field } from 'redux-form';
import styled from 'styled-components';
import { Required } from 'utils/validators';
import Checkbox from '../../../../../../../components/Dashboard/Panels/MenuEditor/components/shared/Checkbox';
import './index.scss';

const DateTimeWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  margin-top: 20px;
`;

const validateDepositAmount = value => {
  if (value <= 0) {
    return 'Deposit amount must be greater than zero';
  }
};

const ContactDetailsForm = ({
  isPaid,
  active,
  formValues,
  menuList,
  handleAttachedMenus,
  bookingTime,
  updateBookingTime,
  updatePhoneNumber,
  isPhoneNumberValid,
  setIsPhoneNumberValid,
}) => {
  const [selectedMenuIds, setSelectedMenuIds] = useState(formValues.menu || []);

  const bookingTimeFormatted = bookingTime
    ? moment(bookingTime).format('YYYY-MM-DDTHH:mm')
    : '';

  const handleBookingTimeChange = value => {
    if (value == '') {
      return 'Date and Time field is required';
    } else {
      updateBookingTime(value);
    }
  };

  return (
    <div style={{ display: active ? 'block' : 'none' }}>
      <form style={{ display: 'flex', flexDirection: 'column' }}>
        <DateTimeWrapper>
          <TextField
            label="Arrival Time"
            type="datetime-local"
            variant="outlined"
            value={bookingTimeFormatted}
            required
            InputLabelProps={{
              shrink: true,
            }}
            onChange={e => {
              try {
                handleBookingTimeChange(e.target.value);
              } catch (error) {
                console.error(error);
              }
            }}
          />
        </DateTimeWrapper>

        <Field
          disabled={isPaid}
          name="name"
          type="text"
          margin="normal"
          variant="outlined"
          component={FormTextField}
          validate={[Required]}
          label="Customer Name"
        />
        <Field
          disabled={isPaid}
          name="email"
          type="email"
          margin="normal"
          variant="outlined"
          component={FormTextField}
          validate={[Required]}
          label="Email Address"
        />
        <Field
          disabled={isPaid}
          name="amount"
          type="number"
          margin="normal"
          variant="outlined"
          component={FormTextField}
          validate={[Required, validateDepositAmount]}
          label="Deposit Amount (£)"
        />
        <Field
          disabled={isPaid}
          name="guest_count"
          type="text"
          margin="normal"
          variant="outlined"
          component={FormTextField}
          label="Guest count (Optional)"
        />
        <Field
          name={'phone'}
          disabled={isPaid}
          component={IntlTelInput}
          placeholder="Phone number"
          props={{
            preferredCountries: ['gb'],
            containerClassName:
              'intl-tel-input tel-wrapper custom-tel-container',
            inputClassName: `form-control custom-tel-input ${
              isPhoneNumberValid ? '' : 'invalid-tel-no'
            }`,
            defaultValue: formValues.phone,
            onPhoneNumberChange: (
              isValid,
              rawInput,
              phoneData,
              formattedNumber
            ) => {
              setIsPhoneNumberValid(isValid);
              updatePhoneNumber(formattedNumber.replace(/ /g, ''));
            },
          }}
        />
        <Field
          disabled={isPaid}
          name="notes"
          type="text"
          margin="normal"
          variant="outlined"
          component={FormTextField}
          label="Notes"
          multiline={true}
        />
        <FormControl>
          <FormLabel classes={{ root: 'input__label marginb__sm' }}>
            Attach Menus
            <TooltipModal>
              <TooltipHeader
                style={{ marginTop: '30px', marginBottom: '12px' }}
              >
                {' '}
                Attach Menus
              </TooltipHeader>
              <TooltipContent>
                <p>
                  Customers can add their food and drink and pay for it as part
                  of their deposit
                </p>
              </TooltipContent>
            </TooltipModal>
          </FormLabel>

          {menuList ? (
            menuList.map(menuData => (
              <Field
                color="primary"
                label={menuData.name}
                className="booking__fee__apply"
                name="attached_menus"
                component={({ input }) => (
                  <Checkbox
                    disabled={isPaid}
                    {...input}
                    onSelect={() => {
                      const menuId = menuData.id;
                      if (selectedMenuIds.includes(menuId)) {
                        const updatedMenuIds = selectedMenuIds.filter(
                          id => id !== menuId
                        );
                        setSelectedMenuIds(updatedMenuIds);
                        handleAttachedMenus(updatedMenuIds);
                      } else {
                        const updatedMenuIds = [...selectedMenuIds, menuId];
                        setSelectedMenuIds(updatedMenuIds);
                        handleAttachedMenus(updatedMenuIds);
                      }
                    }}
                    label={menuData.name}
                    isChecked={selectedMenuIds.includes(menuData.id)}
                  />
                )}
              />
            ))
          ) : (
            <p
              style={{
                fontSize: '10px',
              }}
            >
              You have not created any menus yet, please create menus to attach{' '}
            </p>
          )}
        </FormControl>
      </form>
    </div>
  );
};

export default ContactDetailsForm;



// WEBPACK FOOTER //
// ./src/components/Dashboard/Panels/Bookings/ViewBookingsPanel/BookingDetailsModal/ContactDetailsForm/index.jsx